import type {
  Item,
  OfferItem,
  SelectMode,
  SingleVariantOfferItem,
  UnifiedOffer,
  UnifiedVariant,
  VariantItem,
} from '../SelectProductsModal.types'

export const getItemsFromProducts = (
  products?: UnifiedOffer[],
  selectMode?: SelectMode,
): Item[] => {
  if (!products?.length) return []

  if (selectMode === 'OFFERS') {
    return products.map((offer) => createOfferItem(offer))
  }

  // Select mode === 'VARIANTS'
  return products.reduce<Item[]>((previous, current) => {
    if (current.variants.length < 2) {
      return [...previous, createSingleVariantOfferItem(current, selectMode)]
    }

    const offer = createOfferItem(current)
    const offerVariants = createVariantItems(current.variants)

    return [...previous, offer, ...offerVariants]
  }, [])
}

const createOfferItem = (offer: UnifiedOffer): OfferItem => ({
  type: 'OFFER',
  id: offer.id,
  name: offer.name,
  state: offer.state,
  available: offer.available,
  image: offer.image,
  variantsIds: offer.variants.map((variant) => variant.id),
  hasHsCode: offer.hasHsCode,
  thumbnailType: offer.thumbnailType,
})

const createSingleVariantOfferItem = (
  offer: UnifiedOffer,
  selectMode?: SelectMode,
): SingleVariantOfferItem => ({
  type: 'SINGLE_VARIANT_OFFER',
  id: selectMode === 'VARIANTS' && offer.variants?.[0]?.id ? offer.variants[0].id : offer.id,
  name: offer.name,
  state: offer.state,
  available: offer.available,
  image: offer.image,
  hasHsCode: offer.hasHsCode,
  thumbnailType: offer.thumbnailType,
})

const createVariantItems = (variants: UnifiedVariant[]): VariantItem[] =>
  variants.map((variant) => ({
    type: 'VARIANT',
    name: variant.name,
    id: variant.id,
    offerId: variant.id,
    color: variant.color
      ? {
          label: variant.color.label,
          value: variant.color.value,
        }
      : undefined,
  }))
